import BaseLayout from '../../components/base-layout';
import { PublicClientProvider } from './context/public-client-context';
import { PublicLayout } from './public-layout';

export function PublicPortalFactory() {
    return (
        <BaseLayout>
            <PublicClientProvider>
                <PublicLayout />
            </PublicClientProvider>
        </BaseLayout>
    );
}
